import { useNavigate } from "react-router-dom";
import {
  Body,
  Button,
  Heading,
  MassiveMusicLogo,
} from "@songtradr-one/components-frontend";
import { routes } from "@songtradr-one/shared-common";
import { getSsoClient } from "../../helpers/get-sso-client";
import { Flex } from "../flex/Flex.Parts";
import { Container, ErrorFlagProps, Spacer, text } from "./ErrorFlag.Parts";

export const ErrorFlag = ({
  customHeader,
  customMessage,
  showButton,
}: ErrorFlagProps) => {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    const ssoClient = getSsoClient();
    await ssoClient.actions.signOut(window.location.origin);
  };

  return (
    <Flex $justify="center" $align="center" $grow={0.5}>
      <Container>
        <MassiveMusicLogo />
        <Spacer $height="8rem" />
        <Heading variant="h1">{customHeader || text.header}</Heading>
        <Spacer $height="1.5rem" />
        <Body variant="normal">{customMessage || text.description}</Body>
        <Spacer $height="3rem" />
        {showButton === "backToHomepage" ? (
          <Button
            $variant="important"
            onClick={() => navigate(routes.portal.base)}
          >
            {text.shared.backToHomepage}
          </Button>
        ) : (
          showButton === "signOut" && (
            <Button $variant="important" onClick={handleSignOut}>
              {text.shared.signOut}
            </Button>
          )
        )}
      </Container>
    </Flex>
  );
};
